import { reactive, ref } from 'vue';
import { runtimeConfig } from '@/config/runtime';
import type { AiLang } from '@/types/runtime-config';
import { getVersionMin20 } from './tools';

/** 创建页面使用的多语言工具。 */
export const useLang = () => {
    // 当前配置语言和实际加载成功的语言
    const currentLang = runtimeConfig.lang;
    const lang = ref<AiLang>(currentLang);

    // 保存异步加载的翻译内容
    const translations = reactive<Record<string, string>>({});

    // 根据翻译 key 返回对应文本，未找到时返回 key
    const t = (key: string) => translations[key] ?? key;

    // 错误提示等可选文案需要先确认语言包中确实配置了对应 key。
    const hasTranslation = (key: string) => Object.prototype.hasOwnProperty.call(translations, key);

    // 异步加载指定语言的 JSON 文件
    const loadLanguage = async (targetLang: AiLang) => {
        const baseUrl = runtimeConfig.langBaseUrl.replace(/\/$/, '');
        const response = await fetch(`${baseUrl}/${targetLang}.json?v=${getVersionMin20()}`, {
            headers: { Accept: 'application/json' },
        });

        if (!response.ok) {
            throw new Error(`语言文件加载失败: ${response.status} ${response.url}`);
        }

        const data = await response.json() as Record<string, string>;
        Object.keys(translations).forEach(key => delete translations[key]);
        Object.assign(translations, data);
        lang.value = targetLang;
    };

    return {
        currentLang,
        lang,
        translations,
        t,
        hasTranslation,
        loadLanguage,
    };
};
